var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 31,
    height: 30,
    rx: 2.5,
    stroke: "#4759FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 21.4999H11.5C11.3674 21.4999 11.2402 21.4473 11.1464 21.3535C11.0527 21.2597 11 21.1326 11 20.9999V18.2062C10.9998 18.1413 11.0124 18.0769 11.037 18.0169C11.0617 17.9568 11.098 17.9022 11.1438 17.8562L18.6438 10.3562C18.6903 10.309 18.7457 10.2714 18.8069 10.2458C18.8681 10.2202 18.9337 10.207 19 10.207C19.0663 10.207 19.132 10.2202 19.1931 10.2458C19.2543 10.2714 19.3097 10.309 19.3563 10.3562L22.1438 13.1437C22.191 13.1902 22.2285 13.2457 22.2541 13.3068C22.2797 13.368 22.2929 13.4336 22.2929 13.4999C22.2929 13.5663 22.2797 13.6319 22.2541 13.6931C22.2285 13.7542 22.191 13.8097 22.1438 13.8562L14.5 21.4999Z",
    stroke: "#4759FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21.5H14.5",
    stroke: "#4759FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12L20.5 15.5",
    stroke: "#4759FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.15f92f622d656f3ff1faf86ad3dd9ac9.svg";
export { ForwardRef as ReactComponent };